import LoginForm from "../../components/forms/authorization/LoginForm";
import AuthorizationBase from "./AuthorizationBase";

const LoginPage = () => {
    return(
        <AuthorizationBase variant="login">
            <LoginForm/>
        </AuthorizationBase>
    )
}

export default LoginPage